import * as React from "react";
import Component from "../../AbstractComponent";
import Time from "../../../Time/Time";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import Select from "../../Partials/Material/Select";
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ReactSelect from 'react-select';
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";
import AssignmentServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/AssignmentServiceStatusTypeContainer";
// import { AgencyFeeInterface } from "../../../Entity/Entities/AgencyFee/AgencyFeeInterface";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import Constants from "../../../Action/Constants";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import Store from "../../../../Casadesk/Store/Store";

export class CoachAgencyFee extends Component {

  public state = {
    activeStep: 0,
    openCoach: false,
    isClosePreprocessDialogOpen: false,
    isSaving: false,
    currency: this.props.app.settings.user.currency.getCurrencyId(),
    fixedFee: "0",
    percentageFee: "0",
    fixedPlusPercentageMode: this.props.globalTypes?.FixedPlusPercentageModes?.[this.defaultFixedPlusPercentageModes("FPP_both")],
    vat: "",
    vatPercentage: "",
    firstDate: Time.firstDateNextMonth(),
    lastDate: null,
    dateChoice: "firstDate",
    firstDateError: "",
    chargeTypeIds: [TypeContainer.pickIdFromLabel("Basic_rent")],
    repeatPeriod: PeriodContainer.pickIdFromLabel("monthly"),
    assignmentServiceStatus: AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial"),
    date: Time.firstDateNextMonth(),
    firstDateIsManuallyChanged: false,
    newAgreementId: null,
    chargeTypesError: false,
    fixedFeeError: false,
    percentageFeeError: false,
  };

  constructor(public props) {
    super(props);

    this.onSave = this.onSave.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.updateFPPMode = this.updateFPPMode.bind(this);
  }

  public componentWillMount() {
    this.setState({
      openCoach: this.props.openCoach
    });

    if (this.props.activeStep) {
      this.setState({
        activeStep: this.props.activeStep
      });
    }
    if (this.props.activeContract) {
      this.setState({
        date: this.props.activeContract?.firstDate,
        firstDate: this.props.activeContract?.firstDate
      });
    }
    if (this.props.agencyFee) {
      const { agencyFee } = this.props;
      this.setState({
        fixedFee: this.formatter.simpleFormatNumber(agencyFee.fixedFee),
        percentageFee: agencyFee.percentageFee || 0,
        fixedPlusPercentageMode: agencyFee.fixedPlusPercentageMode,
        vat: agencyFee.vat || 0,
        firstDate: agencyFee.firstDate,
        lastDate: agencyFee.lastDate,
        dateChoice: !agencyFee.firstDate ? "firstDate" : "firstDate",
        chargeTypeIds: agencyFee.chargeTypeIds ? agencyFee.chargeTypeIds : [TypeContainer.pickIdFromLabel("Basic_rent")],
        repeatPeriod: agencyFee.repeatPeriod,
        assignmentServiceStatus: agencyFee.assignmentServiceStatus,
        date: agencyFee.date,
      })
    }

    if (this.props.defaultAgreement) {
      this.setState({
        lastDate: null,
        firstDate: null
      })
    }
	}

  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  //Funcionality for steps
  public startStep1 = () => {
    return this.coachStartStep1();
  }

  public startStep2 = () => {
    return this.coachStartStep2();
  }

  public startStep3 = () => {
    return this.coachStartStep3();
    // TODO save new credit charge
  }

  public startStep4 = () => {
    return this.coachStartStep4();
    // TODO save new credit charge
  }

  //Methods for step logic
  public coachStartStep1 = () => {
    this.plusOneStep();
  }

  public coachStartStep2 = () => {
    // this.onSave();
    this.plusOneStep();
  }

  public coachStartStep3 = () => {
    this.onSave();
  }

  public coachStartStep4 = () => {
    this.plusOneStep();
  }

  public defaultFixedPlusPercentageModes(label) {
    const chargeClass = this.props.globalTypes?.FixedPlusPercentageModes;
    for(const key in chargeClass) {
      if (chargeClass[key].label === label) {
        return chargeClass[key].id
      }
    }
  }

  public onCancel(): any {
    this.clearBackEndErrors()
    if (typeof this.props.onCancel !== "undefined") {
      this.props.onCancel.call(this, this.state.newAgreementId);
    }
  }

  public newRelation(path: string, identifier: number[]): any {
    const pieces = path.split(".");
    const target = Object.keys(Store.getConfigurator().getState()[pieces[0]]?.[pieces[1]] || {})
                      .map((id) => Store.getConfigurator().getState()[pieces[0]]?.[pieces[1]]?.[id])

    return target.filter(entity => {
      if (Array.isArray(identifier) === true) {
        return identifier.indexOf(entity.id) !== -1;
      }

      return entity.id === identifier;
    });
  }

  public saveAgencyFee = (agencyFee): any => {
    this.setState({
      isSaving: true
    })
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_UPDATE_START,
      payload: {
        ...agencyFee,
        id: this.props.agencyFee.id
      },
      onSuccess: () => {
        this.setState({
          activeStep: this.state.activeStep + 1,
          isSaving: false
        })
      },
      onError: (data) => {
        this.setState({
          isSaving: false,
          activeStep: data?.fields?.includes("date") ? 0 : 1
        })
      }
    });
  }

  public addAgencyFee(agencyFee): any {
    this.setState({
      isSaving: true
    })
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_START,
      payload: agencyFee,
      onSuccess: (data) => {
        this.setState({
          activeStep: this.state.activeStep + 1,
          isSaving: false,
          newAgreementId: data?.id
        })
      },
      onError: (data) => {
        this.setState({
          isSaving: false,
          activeStep: data?.fields?.includes("date") ? 0 : 1
        })
      }
    });
  }

  public getCompanyId() {
    const unit = this.newRelation("units.byId", this.props.objectId)[0];
    return unit?.property?.company.data.id;
  }

  public onSave(): any {
    let fixedFee: number = this.state.fixedFee === "" ? 0 : parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.fixedFee)).replace(",", ".")).toFixed(2));
    let percentageFee: number = this.state.percentageFee === "" ? 0 : parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.percentageFee)).replace(",", ".")).toFixed(2));
    if (isNaN(fixedFee) || isNaN(percentageFee) || !this.state.chargeTypeIds.length) {
      return this.setState({
        fixedFeeError: isNaN(fixedFee),
        percentageFeeError: isNaN(percentageFee),
        chargeTypesError: !this.state.chargeTypeIds.length,
        activeStep: 1
      });
    } else {
      this.setState({
        fixedFeeError: false,
        percentageFeeError: false,
        chargeTypesError: false,
      });
    }

    if (!this.props.defaultAgreement && !this.state.firstDate && this.state.dateChoice === "firstDate") {
      return this.setState({
        firstDateError: this.trans("be_ajv_not_validated"),
        activeStep: 1
      });
    } else {
      this.setState({
        firstDateError: ""
      });
    }

    const payload = {
      objectType: this.props.objectType,
      objectId: this.props.objectId,
      currency: this.state.currency,
      companyId: this.getCompanyId(),
      fixedFee: fixedFee || 0,
      fixedPlusPercentageMode: this.state.fixedPlusPercentageMode.id,
      percentageFee: percentageFee || 0,
      vat: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.vat)).replace(",", ".")).toFixed(2)),
      firstDate: this.state.dateChoice === "firstDate" ? Time.formatOrNull(this.state.firstDate) : null,
      lastDate: Time.formatOrNull(this.state.lastDate),
      chargeTypeIds: this.state.chargeTypeIds,
      repeatPeriodId: this.state.repeatPeriod,
      serviceStatusId: this.state.assignmentServiceStatus,
      date: Time.formatOrNull(this.state.date),
    };

    if (typeof this.props.onSave !== "undefined") {
      const res = this.props.onSave.call(this, payload);
      if (res?.payload?.type === "error") {
        return this.setState({
          activeStep: 1
        })
      }
      return this.setState({
        activeStep: this.state.activeStep + 1
      })
    }

    if (this.props.agencyFee) {
      this.saveAgencyFee(payload)
    } else {
      this.addAgencyFee(payload);
    }
  }

  public updateFPPMode(event) {
    const fpp = this.props.globalTypes?.FixedPlusPercentageModes?.[event.target.value];

    this.setState({
      fixedPlusPercentageMode: fpp,
      hasModifiedData: true
    });
  }

  public changeFixedFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    if (this.state.vat) {
      let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.vat)).replace(",", ".")).toFixed(2));
      vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

      let varPercentage = vatNumber / (fixedFee - vatNumber) * 100;

      return this.setState({
        vatPercentage: isFinite(varPercentage) ? this.formatter.simpleFormatNumber(Math.round(varPercentage), false, false) : "",
        fixedFee: amount,
        hasModifiedData: true
      });
    }

    if (this.state.vatPercentage) {
      let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.vatPercentage)).replace(",", ".")).toFixed(2));
      vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

      const vatNumber = fixedFee / (100 + vatPercentageNumber) * vatPercentageNumber;

      return this.setState({
        vat: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
        fixedFee: amount,
        hasModifiedData: true
      });
    }

    return this.setState({
      vat: "",
      vatPercentage: "",
      fixedFee: amount,
      hasModifiedData: true
    });
  }

  public changeVatAmount = (event): void => {
    let vat: string = event.target.value;
    vat = this.formatter.formatSigns(vat);

    let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.fixedFee)).replace(",", ".")).toFixed(2));
    fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

    let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(vat)).replace(",", ".")).toFixed(2));
    vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

    const vatPercentageNumber = vatNumber / (fixedFee - vatNumber) * 100;

    this.setState({
      vat: vat,
      vatPercentage: this.formatter.simpleFormatNumber(Math.round(vatPercentageNumber), false, false),
      hasModifiedData: true
    });
  }

  public changeVatPercentageAmount = (event): void => {
    let vatPercentage: string = event.target.value;
    vatPercentage = this.formatter.formatSigns(vatPercentage);

    let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.fixedFee)).replace(",", ".")).toFixed(2));
    fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

    let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(vatPercentage)).replace(",", ".")).toFixed(2));
    vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

    const vatNumber = fixedFee / (100 + vatPercentageNumber) * vatPercentageNumber;

    this.setState({
      vat: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
      vatPercentage: vatPercentage,
      hasModifiedData: true
    });
  }

  public changePercentageFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    this.setState({
      percentageFee: amount,
      hasModifiedData: true
    });
  }

  public selectDate = (date: Date, identifier: string): void => {
    if (identifier === "firstDate") {
      this.setState({
        [identifier]: date,
        firstDateIsManuallyChanged: true
      })
    }
    if (identifier === "date") {
      this.setState({
        [identifier]: date,
        firstDate: this.state.firstDateIsManuallyChanged ? this.state.firstDate : date
      })
    }
  }

  public changeDateChoice = (event: any): void => {
    const choice: string = event.target.value;

    this.setState({
      dateChoice: choice,
      hasModifiedData: true
    });
  }

  public onChargeTypesSelectChange = (valArray) => {
		const types = !!valArray ? valArray.map(item => item.value) : [];

		this.setState({
      chargeTypeIds: [...types],
      hasModifiedData: true
		});
  }

  public renderChargeTypesSelect = () => {
    const chargeTypes = TypeContainer.getChargeTypesForChargeTemplates("agencyfee")
                      .filter(type => {
                        if(type.removed){
                          return false;
                        }

                        if(TypeContainer.pickIdFromLabel("Stub_receivable") === type.id || TypeContainer.pickIdFromLabel("Stub_payable") === type.id) {
                          return false;
                        }

                        return true;
                      })
                      .map(type => {
                        return ({
                            value: type.id,
                            label: this.formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)
                          });
                        }
                      );

    const customStyles = {
      control: (base, state) => {
        let borderColor = 'rgba(0, 0, 0, 0.23)';
        let boxShadow = 'none !important';
        let outlineColor = "auto";

        if (state.isFocused) {
          borderColor = "#00BCD4 !important";
          boxShadow = "0 0 1px 1px #00BCD4 !important";
          outlineColor = "#00BCD4 !important";

          if (!!this.getErrorFor("chargeTypeIds")) {
            borderColor = "#f44336 !important";
            boxShadow = "0 0 1px 1px #f44336 !important";
            outlineColor = "#f44336 !important";
          }
        } else {
          if (!!this.getErrorFor("chargeTypeIds")) {
            borderColor = "#f44336 !important";
            outlineColor = "#f44336 !important";
          }
        }

        return ({
          ...base,
          border: state.isFocused ? 'none !important' : "auto",
          borderColor: borderColor,
          boxShadow: boxShadow,
          outlineColor: outlineColor,
          outlineStyle: state.isFocused ? "auto !important" : "auto",
          outlineWidth: state.isFocused ? "5px !important"  : "auto",
          '&:hover': {
            borderColor: !!this.getErrorFor("chargeTypeIds") ? '#f44336' : 'black',
          }, // border style on hover
        });
      }
    }

    return (
      <div style={{position: "relative", zIndex: 2}}>
        <ReactSelect
          defaultValue={this.state.chargeTypeIds.map(id => chargeTypes.find(type => type.value === id))}
          isMulti
          options={chargeTypes}
          onChange={this.onChargeTypesSelectChange}
          styles={customStyles}
          placeholder={this.trans("dialog/agencyfee-field/chargetypes-label")}
          className="form-element scroll-to-charge-types"
        />
        {this.state.chargeTypesError && <div className="component-error-text">{this.trans("be_ajv_not_validated")}</div>}
        {!!this.getErrorFor("chargeTypeIds") && <div className="component-error-text">{this.getErrorFor("chargeTypeIds")}</div>}
        <div className="hint-styles-dialog" style={{margin: "-10px 0 10px 0"}}>
          {this.trans("dialog/agencyfee-info/chargetypes")}
        </div>
      </div>
    );
  }

  public changeAssignmentServiceStatus  = (event) => {
    const type: number = event.target.value;
    this.clearBackEndErrors();

    this.setState({
      assignmentServiceStatus: type,
      repeatPeriod: type === AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly")
    });
  }

  public getSteps = () => {
    if (this.props.agencyFee) {
      return [
        this.trans("section/agencyfee-title"),
        this.trans("coach/newagreement/step2/title"),
        this.trans("summary"),
        this.trans("menuitem-finish")
      ]
    }
    return [
      this.trans("coach/newagreement/step1/title"),
      this.trans("coach/newagreement/step2/title"),
      this.trans("summary"),
      this.trans("menuitem-finish")
    ]
  }

  public step1Content = () => (
    <div>
      <div className="main-text-of-step center">
        {this.props.agencyFee ? this.trans("section/agencyfee-title") : this.trans("coach/newagreement/step1/title")}
      </div>
      <div className="info-text-gray" style={{textAlign: 'center'}}>
        {this.trans("coach/newagreement/step1/subtitle")}
      </div>
      <div
        className="fields-wrapper"
        style={{
          display: "flex", flexDirection: "column", alignItems: "center"
        }}
      >
        <DatePickerComponent
          {...this.props}
          id="date"
          name="date"
          className="scroll-to-date"
          label={this.trans("coach/newagreement/date-agreement")}
          initialDate={this.state.date}
          maxDate={this.props.activeContract && this.props.activeContract?.firstDate}
          onChange={date => this.selectDate(date, "date")}
          clearButton={true}
          width="300px"
          error={this.getErrorFor("date")}
        />
        <Select
          className="form-element form-input scroll-to-unitTypeId correct-label-position"
          error={this.getErrorFor("assignmentServiceStatusId")}
          value={this.state.assignmentServiceStatus}
          onChange={this.changeAssignmentServiceStatus}
          htmlFor="assignmentServiceStatusId"
          label={this.trans("page/unitupdate-section/info-changeunitservicestatus/label")}
          name="assignmentServiceStatus" 
          id="assignmentServiceStatus"
          style={{width: "300px"}}
        >
          <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(2).toLowerCase()}`)}</MenuItem>
          <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(5).toLowerCase()}`)}</MenuItem>
          <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(4).toLowerCase()}`)}</MenuItem>
          <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(3).toLowerCase()}`)}</MenuItem>
        </Select> 
      </div>
    </div>
  )

  public step2Content = () => (
    <div>
      <div className="main-text-of-step center">
        {this.trans("coach/newagreement/step2/title")}
      </div>
      <div className="info-text-gray" style={{textAlign: 'center'}}>
        {this.trans("coach/newagreement/step2/subtitle")}
      </div>
      <div className="agencyfee-create-wrapper">
        <div
          style={{
            display: "flex"
          }}
        >
          <div style={{display: "flex", flexDirection: "column", marginRight: "20px"}}>
            <TextField
              autoComplete="off"
              className="form-element form-element-dialog agency-fee-dialog scroll-to-fixedFee"
              type="text"
              label={this.trans("dialog/agencyfee-field/fixedfee-label")}
              value={this.state.fixedFee}
              onChange={this.changeFixedFeeAmount}
              autoFocus={true}
              variant="standard"
              error={!!this.getErrorFor("fixedFee")}
            />
            {this.state.fixedFeeError && <div className="component-error-text">{this.trans("be_ajv_not_validated")}</div>}
          </div>

          <Select
            className="form-element form-element-dialog agency-fee-dialog form-input scroll-to-currency correct-label-position"
            error={this.getErrorFor("currency")}
            value={this.state.currency}
            onChange={this.sync.bind(this, this.syncronizers.CURRENCY)}
            htmlFor="currency"
            label={this.trans("dialog/agencyfee-field/currency-label")}
            name="currency" 
            id="currency"
            disabled={true}
          >
            {this.getCurrencySelectboxes()}
          </Select>
        </div>
        <div className="hint-styles-dialog" style={{margin: "-14px 0 10px 0"}}>
          {this.trans("dialog/agencyfee-info/amount")}
        </div>

        <TextField
          autoComplete="off"
          className="form-element form-element-dialog agency-fee-dialog scroll-to-percentageFee"
          type="text"
          label={this.trans("dialog/agencyfee-field/percentagefee-label")}
          value={this.state.percentageFee}
          onChange={this.changePercentageFeeAmount}
          variant="standard"
          error={!!this.getErrorFor("percentageFee")}
        />
        {this.state.percentageFeeError && <div className="component-error-text">{this.trans("be_ajv_not_validated")}</div>}
        <div className="hint-styles-dialog" style={{margin: "-14px 0 10px 0"}}>
          {this.trans("dialog/agencyfee-info/percentagefee")}
        </div>

        <Select
          className="form-element full-size form-input scroll-to-repeat-period correct-label-position"
          error={this.getErrorFor("repeat-period")}
          disabled={!!this.props.disabled || this.state.assignmentServiceStatus === AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")}
          value={this.state.repeatPeriod}
          onChange={this.sync.bind(this, this.syncronizers.REPEAT_PERIOD)}
          htmlFor="repeatPeriod"
          label={this.trans("dialog/defaultchargetemplates-field/period-label")}
          name="repeatPeriod" 
          id="repeatPeriod"
        >
          {this.getRepeatPeriodAgreementSelectboxes(this.state.assignmentServiceStatus)}
        </Select>

        {this.renderChargeTypesSelect()}

        {
          <Select
            className="form-element form-element-dialog agency-fee-dialog form-input scroll-to-fixedPlusPercentageMode correct-label-position"
            error={this.getErrorFor("fixedPlusPercentageMode")}
            value={this.state.fixedPlusPercentageMode.id}
            onChange={this.updateFPPMode}
            label={this.trans("dialog/agencyfee-field/fixedpluspercentagemode-label")}
            htmlFor="fixedPlusPercentageMode"
            name="fixedPlusPercentageMode"
            id="fixedPlusPercentageMode"
          >
            {
              Object.keys(this.props.globalTypes?.FixedPlusPercentageModes || {}).map((fpp) => {
                let fpps = this.props.globalTypes?.FixedPlusPercentageModes?.[fpp];

                return (
                  <MenuItem key={fpps.id} value={fpps.id}>{this.formatter.checkTranslationType(this.trans(fpps.label), fpps.label)}</MenuItem>
                );
              })
            }
          </Select>
        }

        {
          this.props.showDates && (
            <div>
              <div>
                <div
                  style={{
                    marginRight: "15px",
                    color: "gray"
                  }}
                >
                  {this.trans("dialog/agencyfee-radio/dates-hint")}
                </div>

                <RadioGroup
                  name="dateChoice"
                  value={this.state.dateChoice}
                  onChange={this.changeDateChoice}
                  style={{
                    display: "flex",
                    flexDirection: "row"
                  }}
                >
                  <FormControlLabel
                    value="firstDate"
                    control={<Radio color="primary" />}
                    label={
                      (<span>{this.trans("dialog/agencyfee-field/firstdate-radiobutton")}</span>)}
                  />
                  {/* <FormControlLabel
                    value="contractDate"
                    control={<Radio color="primary" />}
                    label={
                      (<span>{this.trans("dialog/agencyfee-field/startfromcontractdate-label")}</span>)}
                  /> */}
                </RadioGroup>
              </div>

              {
                this.state.dateChoice === "firstDate" && (
                  <DatePickerComponent
                    {...this.props}
                    id="firstDate"
                    name="firstDate"
                    className="scroll-to-firstDate"
                    label={this.trans("dialog/agencyfee-field/firstdate-label")}
                    initialDate={this.state.firstDate}
                    maxDate={this.props.activeContract && this.props.activeContract?.firstDate}
                    onChange={date => this.selectDate(date, "firstDate")}
                    clearButton={true}
                    margin={"0 0 -10px 0"}
                    width="250px"
                    error={this.getErrorFor("firstDate") || this.state.firstDateError}
                  />
                )
              }
            </div>
          )
        }
      </div>
    </div>
  )
  
  public step3Content = () => (
    <div style={{maxWidth: "400px", margin: "auto"}}>
      <div className="main-text-of-step center">
        {this.trans("summary")}
      </div>
      <div className="info-text-gray info-text-flex">
        <span className="summary-label">{this.trans("page/unitupdate-section/info-changeunitservicestatus/label")}:</span>
        <span className="summary-value">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(this.state.assignmentServiceStatus).toLowerCase()}`)}</span>
      </div>
      <div className="info-text-gray info-text-flex">
        <span className="summary-label">{this.trans("coach/newagreement/date-agreement")}:</span>
        <span className="summary-value">{this.formatter.formatDate(this.state.date)}</span>
      </div>
      <div className="info-text-gray info-text-flex">
        <span className="summary-label" style={{width: "170px"}}>{this.trans("dialog/agencyfee-radio/dates-hint")}</span>
        <span className="summary-value">{this.state.dateChoice === "firstDate" ? this.formatter.formatDate(this.state.firstDate) : this.trans("dialog/agencyfee-field/startfromcontractdate-label")}</span>
      </div>
      <div className="info-text-gray info-text-flex">
        <span className="summary-label">{this.trans("dialog/agencyfee-field/fixedfee-label")}:</span>
        <span className="summary-value">{this.state.fixedFee || 0} {this.props.app?.settings?.user?.currency.getIso()}</span>
      </div>
      <div className="info-text-gray info-text-flex">
        <span className="summary-label">{this.trans("dialog/agencyfee-field/percentagefee-label")}:</span>
        <span className="summary-value">{this.state.percentageFee}%</span>
      </div>
      <div className="info-text-gray info-text-flex">
        <span className="summary-label">{this.trans("dialog/defaultchargetemplates-field/period-label")}:</span>
        <span className="summary-value">{this.formatter.checkTranslationType(this.trans(PeriodContainer.pickLabelFromId(this.state.repeatPeriod)), PeriodContainer.pickLabelFromId(this.state.repeatPeriod))}</span>
      </div>
      <div className="info-text-gray info-text-flex">
        <span className="summary-label">{this.trans("dialog/agencyfee-field/chargetypes-label")}:</span>
        <span className="summary-value">
          {this.state.chargeTypeIds && this.state.chargeTypeIds.length > 0 && this.state.chargeTypeIds.map((id, index) => {
            if (index > 0) {
              return `, ${this.formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(id)), TypeContainer.pickLabelFromId(id))}`
            }
            return `${this.formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(id)), TypeContainer.pickLabelFromId(id))}`
          })}
        </span>
      </div>
      <div className="info-text-gray info-text-flex">
        <span className="summary-label" style={{width: "170px"}}>{this.trans("dialog/agencyfee-field/fixedpluspercentagemode-label")}:</span>
        <span className="summary-value">{this.formatter.checkTranslationType(this.trans(this.state.fixedPlusPercentageMode.label), this.state.fixedPlusPercentageMode.label)}</span>
      </div>
    </div>
  )

  public step4Content = () => (
    <div>
      <div className="main-text-of-step center">
        {this.trans("result")}
      </div>
      <div style={{display: "flex", justifyContent: "center", marginBottom: "30px"}}>{this.image.getAvatar("success", { size: 62 })}</div>
      <div className="info-text-gray" style={{textAlign: 'center'}}>
        {this.props.agencyFee ? this.trans("agreement-update-successful") : this.trans("agreement-creation-successful")}
      </div>
    </div>
  )

  public handleNext = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();
    if(activeStep === steps.length - 1) { // it is last step
      this.onCancel();
    } else {
      switch (activeStep) {
        case 0:
          return this.startStep1();
        case 1:
          return this.startStep2();
        case 2:
          return this.startStep3();
      }
    }
  };
  public handleBack = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep - 1
    })
  };

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step);
      case 1:
        return this.stepContent(step);
      case 2:
        return this.stepContent(step);
      case 3:
        return this.stepContent(step);
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step) => {
    return (
      <div>
        {step === 0 && this.step1Content()}
        {step === 1 && this.step2Content()}
        {step === 2 && this.step3Content()}
        {step === 3 && this.step4Content()}
      </div>
    )
  }

  public renderContent = () => {
    const steps = this.getSteps();
    const { activeStep } = this.state;

    return (
      <div className="stepper-wrapper">
        <div className="stepper-container">
        { activeStep !== steps.length &&
          <Stepper activeStep={activeStep}>
            {steps.map((label) => {
              const props = {};
              const labelProps = {};
              return (
                <Step key={label} {...props}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        }
        <div>
          <div className="step-content-wrapper unit-coach" style={{width: "100%"}}>
            {this.getStepContent(activeStep)}
          </div>
        </div>
      </div>
      { activeStep !== steps.length &&
        <div className={`step-content-button-wrapper button-container ${activeStep === steps.length - 1 ? "without-cancel" : ""}`}>
          {activeStep !== steps.length - 1 &&
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                this.setState({
                  isClosePreprocessDialogOpen: true
                })
              }}
              className="cancel-button"
            >
            {this.trans("dialog-button/close")}
            </Button>
          }

          <div>
            {activeStep !== 0 && activeStep !== steps.length - 1 && (
              <Button
                color="primary"
                variant="outlined"
                onClick={this.handleBack}
                // disabled={this.state.disableButtonDuringRequest}
                className="back-button"
              >
                {this.trans("dialog-button/back")}
              </Button>
            )}
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleNext}
            >
            {activeStep === steps.length - 1 ? this.trans("dialog-button/close") : this.trans("coach/propertyowner-button/next")}
          </Button>
          </div>
        </div>
      }
    </div>
    )
  }

  public closePreprocessDilaogOpen = () => {
    this.setState({
      isClosePreprocessDialogOpen: false
    });
  }

  public render() {
    return (
      <div>
        <Dialog
          className={`dialog dialog-window dialog-assistant coach-new-presentation has-button-padding ${this.props.innerDialogClasses}`}
          open={this.state.openCoach}
          onClose={this.onCancel}
          disableBackdropClick={true}
        >
          <DialogContent>
            {this.renderContent()}
          </DialogContent>
        </Dialog>

        <PageTransition isSaving={this.state.isSaving} />

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention")}
          content={
            <div style={{width: "calc(100% - 65px)"}}>
            {this.trans("are-you-sure")
            }
            </div>
          }
          openLeavePrompt={this.state.isClosePreprocessDialogOpen}
          onClose={this.closePreprocessDilaogOpen}
          onlyPositiveButton={true}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={false}
          hideCross={true}
          actions={
            [(
              <Button
              key="modal-cancel-btn"
              color="primary"
              onClick={this.closePreprocessDilaogOpen}
              style={{height: "34px", width: "auto" }}
              >
                {this.trans("label-no")}
              </Button>
            ),
            (
              <Button
              key="modal-add-btn"
              variant="contained"
              color="primary"
              onClick={this.onCancel}
              style={{height: "34px", width: "auto" }}
              >
                {this.trans("label-yes")}
              </Button>
            )]
          }
        />
      </div>
    );
  }
}
